import React, { useEffect } from "react";
import styles from "./DeckForge.module.css";

const DeckForge = () => {
  useEffect(() => {
    document.title = "DeckForge - Criador de Cartas Personalizadas | Fohattech";
  }, []);

  return (
    <section className={styles.pageWrapper}>
      
      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

      {/* CONTEÚDO CENTRAL */}
      <div className={styles.container}>
        
        {/* HEADER SEO */}
        <header className={styles.header}>
          <h1>Criador de Cartas Personalizadas</h1>
          <p>
            Crie e personalize cartas de baralho de forma simples e gratuita.
            Ideal para jogos, projetos criativos e protótipos digitais ou impressos.
          </p>
        </header>

        {/* TOOL */}
        <div className={styles.toolBox}>
          <iframe
            src="/embed/deckforge/index.html"
            title="DeckForge - Criador de Cartas"
            loading="lazy"
          ></iframe>
        </div>

        {/* CONTEÚDO (IMPORTANTE PRO ADS + SEO) */}
        <section className={styles.info}>
          <h2>O que é o DeckForge?</h2>
          <p>
            O DeckForge é uma ferramenta online que permite criar cartas de baralho
            totalmente personalizadas. Você pode montar decks únicos para jogos,
            protótipos ou projetos criativos.
          </p>

          <h3>Principais funcionalidades:</h3>
          <ul>
            <li>✔ Personalização completa das cartas</li>
            <li>✔ Criação de decks personalizados</li>
            <li>✔ Exportação para uso digital</li>
            <li>✔ Download em PDF para impressão</li>
          </ul>

          <h3>Para quem é essa ferramenta?</h3>
          <p>
            Ideal para desenvolvedores de jogos, designers, criadores de conteúdo
            e qualquer pessoa que queira criar cartas personalizadas de forma rápida.
          </p>
        </section>

      </div>

      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

    </section>
  );
};

export default DeckForge;